import { render, staticRenderFns } from "./SettingsPosition.vue?vue&type=template&id=26d797ac&scoped=true&"
import script from "./SettingsPosition.vue?vue&type=script&lang=js&"
export * from "./SettingsPosition.vue?vue&type=script&lang=js&"
import style0 from "../../Style/settings-position.scss?vue&type=style&index=0&id=26d797ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d797ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d797ac')) {
      api.createRecord('26d797ac', component.options)
    } else {
      api.reload('26d797ac', component.options)
    }
    module.hot.accept("./SettingsPosition.vue?vue&type=template&id=26d797ac&scoped=true&", function () {
      api.rerender('26d797ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsPosition.vue"
export default component.exports